module.exports = __webpack_public_path__ + "static/media/success-1.553259d5.m4a";


//////////////////
// WEBPACK FOOTER
// ./src/sounds/success-1.m4a
// module id = 472
// module chunks = 0